import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import FacebookIcon from '../../../../../assets/svg/social/facebook.svg';
import TwitterIcon from '../../../../../assets/svg/social/twitter.svg';
import InstagramIcon from '../../../../../assets/svg/social/instagram.svg';

import { FeedbackError, Image, Input, TranslucentContainer } from '../../../../../components';
import { useIsMobile } from '../../../../../hooks/useIsMobile';

function SocialNetworks({ values, handleChange, handleBlur, touched, errors }) {
  const isMobile = useIsMobile();

  return (
    <TranslucentContainer style={{ width: isMobile ? '100%' : '80%' }}>
      <Grid container justifyContent="space-evenly" paddingTop={isMobile ? 2 : 8}>
        <Grid item xs={12} sm={11} marginBottom={1}>
          <Grid container justifyContent="space-around">
            <Grid xs={1} sm={0.2} marginTop={1.5}>
              <Image
                src={FacebookIcon}
                alt=""
                style={{ width: '2rem', marginRight: isMobile ? 0 : -2 }}
              />
            </Grid>
            <Grid xs={10} sm={11}>
              <Input
                placeholder="Facebook"
                name="facebook"
                type="text"
                value={values.facebook}
                onChange={handleChange}
                onBlur={handleBlur}
                className={errors.facebook && touched.facebook && 'error'}
              />
            </Grid>
          </Grid>
          <FeedbackError name="facebook" errors={errors} touched={touched} />
        </Grid>
        <Grid item xs={12} sm={11} marginBottom={1}>
          <Grid container justifyContent="space-around">
            <Grid xs={1} sm={0.2} marginTop={1.5}>
              <Image
                src={TwitterIcon}
                alt=""
                style={{ width: '2rem', marginRight: isMobile ? 0 : -2 }}
              />
            </Grid>
            <Grid xs={10} sm={11}>
              <Input
                type="text"
                placeholder="Twitter"
                name="twitter"
                value={values.twitter}
                onChange={handleChange}
                onBlur={handleBlur}
                className={errors.twitter && touched.twitter && 'error'}
              />
              <FeedbackError name="twitter" errors={errors} touched={touched} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={11} marginBottom={1}>
          <Grid container justifyContent="space-around">
            <Grid xs={1} sm={0.2} marginTop={1.5}>
              <Image
                src={InstagramIcon}
                alt=""
                style={{ width: '2rem', marginRight: isMobile ? 0 : -2 }}
              />
            </Grid>
            <Grid xs={10} sm={11}>
              <Input
                placeholder="Instagram"
                name="instagram"
                type="text"
                value={values.instagram}
                onChange={handleChange}
                onBlur={handleBlur}
                className={errors.instagram && touched.instagram && 'error'}
              />
              <FeedbackError name="instagram" errors={errors} touched={touched} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </TranslucentContainer>
  );
}

SocialNetworks.propTypes = {
  values: PropTypes.shape({
    facebook: PropTypes.string.isRequired,
    twitter: PropTypes.string.isRequired,
    instagram: PropTypes.string.isRequired,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  touched: PropTypes.shape({
    facebook: PropTypes.string.isRequired,
    twitter: PropTypes.string.isRequired,
    instagram: PropTypes.string.isRequired,
  }).isRequired,
  errors: PropTypes.shape({
    facebook: PropTypes.string.isRequired,
    twitter: PropTypes.string.isRequired,
    instagram: PropTypes.string.isRequired,
  }).isRequired,
};

export default SocialNetworks;
